
export enum PlatformsSortEnum {
    CREATION_DATE = 'CREATION_DATE',
    NAME = 'NAME'
}
